module.exports = __webpack_public_path__ + "static/media/luck.9f839d7f.svg";